module.exports = __webpack_public_path__ + "img/INTERIOR-CIAZ-1.6bebf466.jpg";